import React from "react";
import { Box, Flex, Text, Icon } from "@chakra-ui/react";
import { FiTrendingUp, FiTrendingDown } from "react-icons/fi";

const StatCard = ({
  label,
  value,
  trend,
}) => (
  <Box
    bg="black"
    borderRadius="16px"
    p={5}
    minW="260px"
    border="1px solid"
    borderColor="whiteAlpha.400"
    boxShadow="sm"
    position="relative"
  >
    <Flex justify="space-between" align="flex-start" mb={2}>
      <Text color="whiteAlpha.700" fontSize="lg" fontWeight="medium">
        {label}
      </Text>
      <Flex
        align="center"
        bg="blackAlpha.700"
        px={2}
        py={1}
        borderRadius="8px"
        fontSize="sm"
        color="whiteAlpha.900"
        fontWeight="semibold"
        border="1px solid"
        borderColor="whiteAlpha.400"
        gap={1}
      >
        <Icon as={!trend?.isDown ? FiTrendingUp : FiTrendingDown} boxSize={4} />
        <Text>{trend?.text || trend}</Text>
      </Flex>
    </Flex>
    <Text color="whiteAlpha.900" fontSize="3xl" fontWeight="bold">
      {value}
    </Text>
  </Box>
);

export default StatCard;